// Alerts client — query persisted alerts + (via TestUi) inspect captured webhooks.

import { fetchJson, URLS } from "./client";
import type { AlertSummaryDto, WebhookCaptureDto } from "./types";

export function listAlerts(strategyId: string): Promise<AlertSummaryDto[]> {
  return fetchJson<AlertSummaryDto[]>(`${URLS.orchestrator}/Strategies/${strategyId}/Alerts`);
}

export function recentWebhooks(limit = 50): Promise<WebhookCaptureDto[]> {
  return fetchJson<WebhookCaptureDto[]>(`${URLS.testUi}/webhooks/recent?limit=${limit}`);
}
